import { compose } from 'redux'

// higher-order components
import withQueryResults from 'components/shared/withQueryResults'
import withPathname from 'components/shared/withPathname'
import withRedux from './withRedux'
import withQuery from './withQuery'
import withMutation from './withMutation'
import withEventHandlers from './withEventHandlers'
import withFormResults from 'components/shared/withFormResults'

// presentational components
import UI from './UI'

const withCartForm = options => {
  const { redirect, onSuccess } = options

  const withCartFormResults = withFormResults({
    mutation: 'saveCart',
    field: 'cart',
    successMessage: 'Cart saved',
    onSuccess,
    redirect
  }) // for mutation result handling

  return compose(
    withPathname, // for nav buttons
    withRedux, // for fetching cart form
    withQueryResults, // for handling query errors
    withQuery, // for fetching account data
    withCartFormResults,
    withMutation, // for saving cart data
    withEventHandlers // for handling clicking "save"
  )
}

// for account manager
export default withCartForm({ redirect: '/plans/checkout' })(UI)

// export HOC for registration
export { withCartForm }
